import { FileReadWriteState } from './types';

/**
 * The default permission of editing a document
 */
export function GET_DEFAULT_FILE_READ_WRITE_STATE(): FileReadWriteState {
  return FileReadWriteState.Edit;
}
